// import Util from '@/assets/libs/util'
// import LocaleController from '@/assets/controllers/LocaleController'

export default {
  state: {
    cart: [],
    backupCart: [],
    comandasAgregadas: []
  },
  getters: {
    getCart: (state) => state.cart,
    isCartEmpty: (state) => state.cart.length === 0,
    getCartLength: (state) => state.cart.length
  },
  mutations: {
    addToCart (state, prod) {
      prod.index = state.cart.length - 1
      state.cart.push(prod)
    },
    clearCart (state, data) {
      state.cart = []
      state.backupCart = []
    },
    // Esta funcao é usada para limpeza de carrinho decorrente de acoes do sistema
    resetCart (state) {
      state.cart = []
      state.backupCart = []
    },
    deleteProduct: function (state, key) {
      state.cart.splice(key, 1)
    },
    filterComanda (state, saleCode) {
      state.comandasAgregadas = state.comandasAgregadas.filter(ca => ca.saleCode !== saleCode)
      state.cart = state.cart.filter(ct => ct.comandaNumber !== saleCode)
    },
    overrideCart (state, cart) {
      state.cart = cart
    },
    decreaseQtty (state, key) {
      state.cart[key].quantity--
    },
    increaseQtty (state, key) {
      state.cart[key].quantity++
    },
    editProduct (state, prod) {
      state.cart.forEach((cartProd, idx) => {
        if (cartProd.index === prod.index) {
          state.cart[idx] = prod
        }
      })
    }
  },
  actions: {
    addToCart ({ commit }, prod) {
      commit('addToCart', prod)
    },
    // clearCart ({ commit }, self, route) {
    //   commit('clearCart', self, route)
    // },
    clearCart ({ commit }, data) {
      commit('clearCart', data)
    },
    resetCart ({ commit }) {
      commit('resetCart')
    },
    deleteProductCart ({ commit }, key) {
      commit('deleteProduct', key)
    },
    filterComanda ({ commit }, saleCode) {
      commit('filterComanda', saleCode)
    },
    overrideCart ({ commit }, cart) {
      commit('overrideCart', cart)
    },
    isCartEmpty ({ commit }) {
      commit('isCartEmpty')
    },
    decreaseQttyCart ({ commit }, key) {
      commit('decreaseQtty', key)
    },
    increaseQttyCart ({ commit }, key) {
      commit('increaseQtty', key)
    },
    editProduct ({ commit }, data) {
      commit('editProduct', data)
    }
  }
}
